
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import Component from "vue-class-component";
import Vue from "vue";
import CertificatesTable from "@/features/certificates/components/CertificatesTable.vue";

@Component({
    components: {
        HeadingWave,
        CertificatesTable
    }
})
export default class Certificates extends Vue {
}
